import { TextField, Autocomplete } from "@mui/material";

const options = ["pending", "done", "rejected"];

const SelectAdminNotesStatus = ({ ref, ...props }) => {
  return (
    <Autocomplete
      {...props}
      ref={ref}
      options={options}
      getOptionLabel={(option) => option}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          helperText={props.helpertext}
          label={props.label || "Status"}
          disabled={props.disabled}
        />
      )}
    />
  );
};

export default SelectAdminNotesStatus;
